/* eslint eqeqeq: "off" */
import React, { useEffect } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Col, Collapse, Image, Row } from "antd";
import useMedia from "use-media-antd-query";
import PackageFooter from "./package-footer";
// import { useHistory } from "react-router";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  loadPackagesFaqList,
  loadPackagesFaqMainList,
  loadPackagesList,
} from "../../store/packages/actions";
import { FaHotel } from "react-icons/fa";
import { IoCarSportSharp } from "react-icons/io5";
import { PiBinocularsBold } from "react-icons/pi";
import { GiHotMeal } from "react-icons/gi";
import { Link } from "react-router-dom";
import { DownloadOutlined } from "@mui/icons-material";

const PackageDetails = (props) => {
  const media = useMedia();
  // const history = useHistory();
  const dispatch = useDispatch();
  const categoryId =
    props && props.destinationData !== undefined
      ? props.destinationData.packageCategoryName
      : "";
  const destinationId =
    props && props.destinationData ? props.destinationData._id : "";

  //store integrations
  // const paramsDomestic = "?category=domestic";
  // const paramsInternational = "?category=international";
  useEffect(() => {
    if (destinationId !== "" && categoryId == undefined) {
      dispatch(
        loadPackagesList(
          "?destinationIds=" +
            destinationId +
            "&sortFilter=newest-first&durationDays=0-2"
        )
      );
      dispatch(loadPackagesFaqList(destinationId));
    } else if (
      destinationId !== "" &&
      categoryId !== undefined &&
      categoryId !== ""
    ) {
      dispatch(
        loadPackagesList(
          "?packageCatId=" +
            destinationId +
            "&sortFilter=newest-first&durationDays=0-2"
        )
      );
      dispatch(loadPackagesFaqList(destinationId));
    } else {
      dispatch(loadPackagesFaqMainList());
      dispatch(loadPackagesList("?sortFilter=newest-first&durationDays=0-2"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [destinationId]);

  const {
    packages_list = [],
    packages_faq_list = [],
    packages_faq_main_list = [],
  } = useSelector((state) => state.Packages);

  const packageDetailsData =
    packages_list && packages_list.datum && packages_list.datum;
  //main package data table
  const packageDataTable =
    packages_list &&
    packages_list.datum &&
    packages_list.datum.packageList.length > 0
      ? packages_list.datum.packageList.map((data) => {
          return {
            destinationId: data.destinationId,
            itineraries: data.itineraries,
            days:
              data.itineraries !== undefined && data.itineraries.length > 0
                ? data.itineraries.length + " Days"
                : 0,
            nights:
              data.itineraries !== undefined && data.itineraries.length > 0
                ? parseFloat(data.itineraries.length - 1) + " Nights"
                : 0,
            startingFrom:
              data.lowestPrice < 10000
                ? "₹ " + parseFloat(data.lowestPrice + 600)
                : data.lowestPrice >= 10000 && data.lowestPrice < 20000
                ? "₹ " + parseFloat(data.lowestPrice + 1500)
                : data.lowestPrice >= 20000 && data.lowestPrice < 50000
                ? "₹ " + parseFloat(data.lowestPrice + 2000)
                : data.lowestPrice >= 50000 && data.lowestPrice < 100000
                ? "₹ " + parseFloat(data.lowestPrice + 4000)
                : "",
            Price: "₹ " + data.lowestPrice,
            packageCategoryId: data.packageCategoryId,
            packageCode: data.packageCode,
            hotels: data.packageIncludes ? data.packageIncludes.hotels : false,
            meals: data.packageIncludes ? data.packageIncludes.meals : false,
            transport: data.packageIncludes
              ? data.packageIncludes.transport
              : false,
            sightSeeing: data.packageIncludes
              ? data.packageIncludes.sightSeeing
              : false,
            packageName: data.packageName,
            imageUrl:
              data.thumbnailsImages && data.thumbnailsImages.length > 0
                ? data.thumbnailsImages[0].imageUrl
                : "",
            Duration: data.tourPlan,
            _id: data._id,
          };
        })
      : [];
  //faq main list

  const packageFaqMainList =
    packages_faq_main_list &&
    packages_faq_main_list &&
    packages_faq_main_list.length > 0
      ? packages_faq_main_list
          .filter((faq) => faq.parentType == "package")
          .map((data, index) => {
            return {
              key: index + 1,
              label: `Q. ${data.question}?`,
              children: (
                <div>
                  {data.answer ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.answer ? data.answer : "",
                      }}
                      className="text-[12px] font-normal"
                    ></div>
                  ) : (
                    <p className="text-[12px] text-center font-normal">
                      {"No data found.."}
                    </p>
                  )}
                </div>
              ),
            };
          })
      : [];
  const packageFaqList =
    packages_faq_list && packages_faq_list && packages_faq_list.length > 0
      ? packages_faq_list.map((data, index) => {
          return {
            key: index + 1,
            label: `Q. ${data.question}?`,
            children: (
              <div>
                {data.answer ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.answer ? data.answer : "",
                    }}
                    className="text-[12px] font-normal"
                  ></div>
                ) : (
                  <p className="text-[12px] text-center font-normal">
                    {"No data found.."}
                  </p>
                )}
              </div>
            ),
          };
        })
      : [];

  const packageDescriptionDetails =
    packageDetailsData && packageDetailsData.desc;

  const temp = document.createElement("div");
  temp.innerHTML = packageDescriptionDetails;

  // Get the plain text only
  const packageDescription = temp.textContent || temp.innerText || "";
  return (
    <React.Fragment>
      <Col md={24} lg={24} xl={24} xxl={24}>
        <Row>
          <Col
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            sm={24}
            xs={24}
            className="pl-5 pr-5 pt-3 pb-3"
          >
            <div
              style={{
                fontFamily: "Poppins",
                marginBottom: "1.5rem",
                //   boxShadow: "1px 1px 1px 2px lightgray",
              }}
            >
              <div className="flex text-[24px] font-extrabold text-start ">
                <h2 className="">
                  {packageDetailsData && packageDetailsData.title
                    ? packageDetailsData.title
                    : "Tour Packages"}
                </h2>
                {/* <span className="ml-1">of Booking With Us</span> */}
              </div>
              <p
                style={{
                  width: "fit-content",
                }}
                className="text-[13px] mt-2 ml-1 font-medium text-start"
              >
                {packageDetailsData &&
                packageDetailsData.desc &&
                packageDescription !== undefined
                  ? packageDescription
                  : ""}
              </p>
            </div>

            <Row className="flex flex-row">
              {packageDataTable.map((data, index) => {
                return (
                  <Col
                    md={24}
                    lg={8}
                    xl={8}
                    xxl={6}
                    sm={24}
                    xs={24}
                    className={
                      (media !== "md" || media !== "sm" || media !== "xs") &&
                      (index === 2 || index === 5)
                        ? "pr-5 pb-3"
                        : // ? "pr-5 pb-3 cursor-pointer"
                          "pr-5 pb-3"
                      // : "pr-5 pb-3 cursor-pointer"
                    }
                  >
                    <div
                      style={{
                        fontFamily: "Poppins",
                        //   boxShadow: "1px 1px 1px 2px lightgray",
                        border: "1px solid rgba(200, 203, 206, 0.81)",
                      }}
                      key={index}
                      className={
                        // data.name == "Exciting Deals"
                        //   ? "cursor-pointer mb-3 bg-white shadow-lg rounded-sm"
                        //   :
                        "mb-3 bg-white shadow-lg rounded-sm"
                      }
                    >
                      <div className="">
                        <Image
                          //   src={data.imageUrl}
                          src={data.imageUrl}
                          preview={false}
                          height={200}
                          width={"100%"}
                          className="text-start relative"
                        />
                        <h1
                          style={{
                            padding: "2px 6px",
                            top: 160,
                            right: 35,
                            borderRadius: "8px",
                          }}
                          className="absolute bg-[#0000009c] text-[11px] text-[white]"
                        >
                          {data.nights}
                        </h1>
                        <div>
                          <div className="pb-2 pr-3 pl-3 border border-b-1 border-x-0 border-t-0">
                            <Link
                              to={{
                                pathname: `/package-details/${data.packageName}`,
                                state: data,
                              }}
                            >
                              <h1 className="mt-1 text-[15px] mb-1 text-sm font-extrabold">
                                {data.packageName}
                              </h1>
                            </Link>
                            <p className="text-[13px]">{data.Duration}</p>
                          </div>
                          <div className="flex w-[100%] pl-3 pt-3 pb-3 border border-b-1 border-x-0 border-t-0">
                            {data.hotels === true ? (
                              <div className="pr-4">
                                <FaHotel className="text-center text-[26px] w-[100%]" />
                                <p className="text-start mt-1 text-[12px]">
                                  {"Hotel"}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            {data.sightSeeing === true ? (
                              <div className="pr-4">
                                <PiBinocularsBold className="text-center text-[26px] w-[100%]" />
                                <p className="text-start mt-1 text-[12px]">
                                  {"Sightseeing"}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            {data.transport === true ? (
                              <div className="pr-4">
                                <IoCarSportSharp className="text-center text-[26px] w-[100%]" />
                                <p className="text-start mt-1 text-[12px]">
                                  {"Transfer"}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                            {data.meals === true ? (
                              <div className="pr-4">
                                <GiHotMeal className="text-center text-[26px] w-[100%]" />
                                <p className="text-start mt-1 text-[12px]">
                                  {"Meal"}
                                </p>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="flex w-[100%] pl-3 pt-1 pb-1">
                            {/* <div> */}
                            <h1 className="text-[12px]">Starting from</h1>
                            <p
                              style={{
                                textDecorationLine: "line-through",
                              }}
                              className="text-[13px] ml-2 font-semibold"
                            >
                              {data.startingFrom}
                            </p>
                            {/* </div> */}
                          </div>
                          <div className="flex justify-between w-[100%] pl-3 pb-3">
                            <div className="">
                              <h1 className="text-[20px] text-[black] font-extrabold">
                                {data.Price}
                              </h1>
                            </div>
                            <Link
                              to={{
                                pathname: `/package-details/${data.packageName}`,
                                state: data,
                              }}
                              className="text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                              style={{
                                borderRadius: "25px",
                                // border: "1px",
                                // padding: "4px 20px",
                                fontFamily: "Poppins",
                                background: "#eb3e43",
                                padding: "4px 30px",
                                color: "white",
                                cursor: "pointer",
                              }}
                              // onClick={() =>
                              //   history.push({
                              //     pathname: `/package-details/${data.packageName}`,
                              //     state: data,
                              //   })
                              // }
                            >
                              <h1 className="">View Package</h1>
                            </Link>
                          </div>
                          <div className="w-[100%] pl-3 pb-3 mt-[-20px]">
                            <p className="text-[11px]">
                              Per Person on twin sharing
                            </p>
                          </div>
                        </div>
                        {/* <div className="bg-[#ff373c29] p-3">
                          <div className="flex text-[14px]">
                            <h1>No Cost Emi Starts from</h1>
                            <h1 className="mr-1 ml-1">{data.EMIFrom}</h1>
                            <h1 className="text-[#eb3e43] text-[12px] ml-2">
                              See option
                            </h1>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </Col>
                );
              })}
              {/* <Row>
                  <Col md={24} lg={24} xl={24} xxl={24}>
                  </Col>
                </Row> */}
            </Row>
            <Row className="mt-3">
              <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                <div
                  style={{
                    fontFamily: "Poppins",
                    marginBottom: "1.5rem",
                    //   boxShadow: "1px 1px 1px 2px lightgray",
                  }}
                >
                  <div className="flex text-[22px] font-extrabold text-start ">
                    <h2 className="">
                      {" "}
                      {packageDetailsData && packageDetailsData.title
                        ? packageDetailsData.title
                        : ""}{" "}
                      Description
                    </h2>
                    {/* <span className="ml-1">of Booking With Us</span> */}
                  </div>
                  <p
                    style={{
                      width: "fit-content",
                    }}
                    className="text-[13px] mt-2 ml-1 font-medium text-start"
                  >
                    {packageDetailsData && packageDetailsData.descDetail
                      ? packageDetailsData.descDetail
                      : ""}
                    {/* Renowned as the paradise on earth, Kashmir stands as the
                    crown jewel of picturesque beauty, captivating the souls of
                    travel fanatics worldwide. With majestic Himalayas,
                    snow-peak mounts, tranquil valleys, and an unparalleled
                    array of adventures add the magical charm to this
                    destination. From the scenic wonderland of Gulmarg to the
                    evergreen trails of Pahalgam, you can visit them all to
                    capture the essence of Kashmir's enriching cultural
                    heritage. So, are you all set to soak into the timeless
                    allure of this “Alp of East” to fabricate special moments
                    amidst breathtaking vistas? If yes, then why wait? Book your
                    dream Kashmir trip packages with PlanMiTrip and immerse
                    yourself in a promising journey filled with enchantment and
                    serenity. */}
                  </p>
                  {/* <p
                    style={{
                      width: "fit-content",
                    }}
                    className="text-[13px] mt-2 ml-1 font-medium text-start"
                  >
                    At PlanMiTrip, we comprise a vast selection of specially
                    designed Kashmir trip packages that are finely crafted to
                    exceed the expectations of voyagers at affordable values.
                    Presently, the package price ranges from INR 9,999 to INR
                    70,132 per person. Under this package, you get a magnificent
                    opportunity to witness the beautiful Srinagar, Sonmarg,
                    Gulmarg, Pahalgam, Shalimar Bagh Mughal Garden, and other
                    heavenly destinations. You are also facilitated with an
                    inclusive everyday plan, tour guides, and proper
                    descriptions of all the amenities.
                  </p> */}
                </div>
              </Col>
            </Row>
            <Col md={24} lg={24} xl={24} xxl={24} className="mt-[20px]">
              <Row>
                <Col
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  sm={24}
                  xs={24}
                  className="pr-5 pt-3 pb-3"
                >
                  <div
                    style={{
                      fontFamily: "Poppins",
                      marginBottom: "1.5rem",
                      //   boxShadow: "1px 1px 1px 2px lightgray",
                    }}
                  >
                    <div className="flex text-[24px] font-extrabold text-start ">
                      <h2 className="">Frequently Asked Questions(FAQ)</h2>
                      {/* <span className="ml-1">of Booking With Us</span> */}
                    </div>
                  </div>
                </Col>
                <Col
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  sm={24}
                  xs={24}
                  className="pr-5 pb-3"
                >
                  <Collapse
                    items={
                      packageFaqMainList.length > 0
                        ? packageFaqMainList
                        : packageFaqList
                    }
                    expandIcon={<DownloadOutlined />}
                    expandIconPosition="end"
                    className="font-semibold text-[16px] border-none"
                    style={{
                      fontFamily: "Poppins",
                      background: "none",
                    }}
                    //   bordered
                    bordered={false}
                  />
                </Col>
              </Row>
            </Col>
            {/* <PackageFooter /> */}
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
PackageDetails.propTypes = {
  location: PropTypes.any,
  destinationData: PropTypes.any,
};

export default PackageDetails;
